// Single canonical order-source classifier for the whole partner board (badge + ready styling).
// Legacy / missing / unrecognized values are NEVER treated as online.
export function orderSourceKind(o) {
  const s = o?.order_source;
  if (s === "RESTAURANT_INTERNAL") return "local";
  if (s === "CUSTOMER_APP") return "online";
  return "unknown";
}

export const SOURCE_LABEL = { local: "Lokal", online: "Online", unknown: "Drugo" };
